import { render, staticRenderFns } from "./AllVis.vue?vue&type=template&id=272ac684&"
import script from "./AllVis.vue?vue&type=script&lang=js&"
export * from "./AllVis.vue?vue&type=script&lang=js&"
import style0 from "./AllVis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports